import React from "react";
import classNames from "classnames";
import "./index.scss";

import IconButton from "../IconButton";

const IconSwitchControl = ({ value, on, off, onSelect }) => {
    const handleSwitchOn = e => {
        e && e.stopPropagation();
        return new Promise(resolve=> {
            resolve();
            onSelect && onSelect(true);
        })
    }
    const handleSwitchOff = e => {
        e && e.stopPropagation();
        return new Promise(resolve=> {
            resolve();
            onSelect && onSelect(false);
        })
    }
    return (
        <div className={classNames("iconSwitchControl")}>
            <div className={classNames("iconSwitchControlItem", "on", { active: value })} onClick={handleSwitchOn}>
                <IconButton isIcon={true} iconName={on || ""} onClick={handleSwitchOn} />
            </div>
            <div className={classNames("iconSwitchControlItem", "off", { active: !value })} onClick={handleSwitchOff}>
                <IconButton isIcon={true} iconName={off || ""} onClick={handleSwitchOff} />
            </div>
        </div>
    );
}

export default IconSwitchControl;
